
import {
  defineComponent,
  onMounted,
  computed,
  watchEffect,
  ref,
  inject,
  reactive,
  watch,
} from "vue";
import { useStore } from "vuex";
import { loaderStart, loaderDone } from "@/services/Loader";
import { showMessage } from "@/services/MessageService";
import { i18n } from "@/i18n";
import Surveys from "@/components/program/Surveys.vue";
import { Calendar } from "v-calendar";
import { ProgramEvents } from "@/vue-core/models/ProgramEvents.model";
import "v-calendar/dist/style.css";
export default defineComponent({
  components: {
    Surveys,
    Calendar,
  },
  setup() {
    const store = useStore();
    const eventData = computed(() => {
      return store.getters["user/eventData"];
    });
    const statusPaid = computed(() => {
      const isLogged = store.getters["user/isLogged"];
      if (isLogged) return !store.getters["user/isPaid"];
      return false;
    });
    const courseData: Array<{ [key: string]: any }> = reactive([]);
    const showGeneralPhone = ref(false);
    const generalPhone = ref("");
    const emitter: any = inject("emitter");
    const isAvailableEventCertificate = ref(false);
    let certificatesAvailables: string[] = reactive([]);
    const participantData = computed(
      () => store.getters["user/participantData"]
    );
    function filterDate(date) {
      const formatDate = new Date(date);
      return `${formatDate.getDate()}/${
        formatDate.getMonth() + 1
      }/${formatDate.getFullYear()}`;
    }
    function filterTime(time) {
      let formatTime = new Date(time);
      if (time._seconds) formatTime = new Date(time._seconds * 1000);
      if (time.seconds) formatTime = new Date(time.seconds * 1000);
      const leadingZero = (num) => `0${num}`.slice(-2);
      return (
        leadingZero(formatTime.getHours()) +
        ":" +
        leadingZero(formatTime.getMinutes())
      );
    }
    const openSurvey = (formData) => {
      emitter.emit("openSurvey", formData);
    };
    function goTo(to) {
      window.open(to, "_blank");
    }
    function filterProfileImage(profileImage) {
      if (profileImage) {
        return profileImage;
      } else {
        return "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png";
      }
    }
    const showSurvey = (course: ProgramEvents) => {
      if (!course) return false;
      if (course.surveyURL) return true;
      return false;
    };
    watchEffect(() => {
      if (eventData.value.generalPhone) {
        showGeneralPhone.value = true;
        generalPhone.value = eventData.value.generalPhone;
      } else {
        showGeneralPhone.value = false;
      }
    });
    const validCardEvent = async () => {
      loaderStart();
      isAvailableEventCertificate.value = await store.dispatch(
        "user/checkEventEntranceRecord"
      );
      loaderDone();
    };
    const validDownloadCertificated = (lastEndDate, id) => {
      const endDate = new Date(lastEndDate);
      if (endDate.getTime() < Date.now()) {
        if (
          certificatesAvailables.find((idCertificate) => idCertificate === id)
        )
          return true;
      }
      return false;
    };
    const validCourseDownloadCertificated = (scheduledDates, id) => {
      const dates = JSON.parse(JSON.stringify(scheduledDates));
      dates.sort(function (a, b) {
        const endDateA = new Date(a.endDate.seconds * 1000);
        const endDateB = new Date(b.endDate.seconds * 1000);
        return endDateA.getTime() < endDateB.getTime()
          ? -1
          : endDateA.getTime() > endDateB.getTime()
          ? 1
          : 0;
      });
      const lastEndDate = new Date(dates.pop().endDate.seconds * 1000);
      return validDownloadCertificated(lastEndDate, id);
    };
    const onDownloadCertificate = async (programID) => {
      loaderStart();
      try {
        if (programID)
          await store.dispatch("program/downloadCourseCertificate", {
            programID,
          });
        else await store.dispatch("program/downloadEventCertificate");
      } catch (error) {
        showMessage({
          title: i18n.global.t(
            "program.courses.errorDownloadCertificate.title"
          ),
          message: i18n.global.t(
            "program.courses.errorDownloadCertificate.message"
          ),
          type: "error",
        });
      } finally {
        loaderDone();
      }
    };
    const courses = computed(() => store.getters["user/courses"]);
    watch(courses, () => {
      fillCourses(courses.value);
    });
    onMounted(async () => {
      loaderStart();
      await store.dispatch("user/getCourses");
      certificatesAvailables = await store.dispatch(
        "event/getCertificatesAvailables"
      );
      fillCourses(courses.value);
      await validCardEvent();
      loaderDone();
    });
    const fillCourses = (courses: Array<ProgramEvents>) => {
      courseData.length = 0;
      for (let i = 0; i < courses.length; i++) {
        const course = courses[i];
        if (course.scheduledDates) {
          const arrayDates: Array<{
            dates: Date;
            highlight: true;
            popover: { label: string };
          }> = [];
          for (const dateSchedule of course.scheduledDates) {
            arrayDates.push({
              dates: trasnformFirebaseDatetoDate(dateSchedule.startDate),
              highlight: true,
              popover: {
                label: transformEventHours(
                  dateSchedule.startDate,
                  dateSchedule.endDate
                ),
              },
            });
          }
          courseData.push({
            ...course,
            calendarDates: arrayDates,
          });
        }
      }
    };
    const trasnformFirebaseDatetoDate = (date) => date.toDate();
    const transformEventHours = (startDate, endDate) => {
      return `${convertHours(startDate.toDate())} - ${convertHours(
        endDate.toDate()
      )}`;
    };
    function convertHours(date: Date) {
      let hours: string | number = date.getHours();
      let minutes: string | number = date.getMinutes();
      let seconds: string | number = date.getSeconds();
      const ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      const strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    }
    return {
      participantData,
      statusPaid,
      courseData,
      goTo,
      showGeneralPhone,
      generalPhone,
      filterProfileImage,
      openSurvey,
      showSurvey,
      onDownloadCertificate,
      eventData,
      isAvailableEventCertificate,
      validDownloadCertificated,
      filterTime,
      filterDate,
      validCourseDownloadCertificated,
    };
  },
});
